<template>
    <div class="theme-master">
        <SmuToast :toasts="toasts" />
        <SmuSite :sidebar-shown="sidebarOpen">
            <template #header>
                <SmuHeader
                    ref="headerRef"
                    :title="appName"
                    :width
                    :subtitle="$t('frontend.master_administration')"
                >
                    <template #sidebar-toggle>
                        <SmuShowSidebarToggle v-model="sidebarOpen" />
                    </template>
                    <template #center>
                        <PageHeaderEditState v-if="hasChanges" />
                        <BreadCrumps v-if="!hasChanges && isNormalPage" />
                    </template>
                    <template #right-side>
                        <div v-if="!hasChanges" class="relative">
                            <LanguageDropdown />
                        </div>
                        <div
                            v-if="user && !hasChanges"
                            data-testid="header-user-menu"
                        >
                            <SmuUserMenu :user="user">
                                <SmuUserMenuItem
                                    data-testid="header-user-menu-logout"
                                    icon="arrow-right-from-bracket"
                                    @click="logout"
                                >
                                    {{ $t("helpers.buttons.logout") }}
                                </SmuUserMenuItem>
                            </SmuUserMenu>
                        </div>
                    </template>
                    <span>{{ route.meta.title?.() }}</span>
                </SmuHeader>
            </template>
            <template v-if="user" #menue>
                <div class="flex h-full flex-col justify-between">
                    <div><PageMainMenu /></div>
                    <div><PageDefaultFooter /></div>
                </div>
            </template>
            <slot />
        </SmuSite>
    </div>
</template>

<script setup lang="ts">
/* eslint-disable */
import { SmuHeader, type PageWidth } from "@smakecloud/smake-ui";
import { aliasMap } from "~/lib/shortcuts";
import { useSidebarStore } from "~/stores/useSidebarStore";

const { useToast } = await import("@smakecloud/smake-ui");

const { data } = storeToRefs(useUserStore());

const route = useRoute();
const sidebarStore = useSidebarStore();
const { sidebarOpen } = storeToRefs(sidebarStore);

const user = data;

const appName = computed(() => {
    return data.value?.master.name ?? "";
});

const { logout } = useTokenStore();

const { hasChanges } = useUnsavedChangesHeader();

const { toasts } = useToast();

useHead({
    titleTemplate: (title) =>
        title
            ? `${title} - Smake Master Administration`
            : "Smake Master Administration",
    meta: [{ property: "og:title", content: "Smake Master Administration" }],
});

const isNormalPage = computed(() => {
    if (isGuestPage(route) || is404Page(route)) return false;

    return true;
});

const keys = useMagicKeys({
    aliasMap,
    passive: false,
});

whenever(keys.escape!, () => {
    sidebarOpen.value = false;
});

const width = computed(() => route.meta.width as PageWidth);
</script>
